<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { instance as api } from '@/helpers/api';
import { useGlobals } from '@/helpers/globals';
import { NewsCollection } from '@/models/News';
import dayjs from 'dayjs';

const news = new NewsCollection();
const loading = ref(false);
onMounted(async () => {
    loading.value = true;
    const res = await api().post('/news/getNews', {
        kanton: useGlobals().customer
    });
    news.push(res.data.records);
    loading.value = false;
})
</script>

<template>
    <div v-if="news">
        <div v-for="n in news.getModels()" :key="n.id + '_static'">
            <v-card-text v-if="n.statische_anzeige">
                <h2>{{ n.titel }}</h2>
                <div v-html="n.inhalt"></div>
            </v-card-text>
        </div>
        <div v-for="n in news.getModels()" :key="n.id + '_dynamic'">
            <v-card-text v-if="!n.statische_anzeige">
                <h2>{{ n.titel }}</h2>
                <h3>{{ n.anzeige_von ? dayjs(n.anzeige_von).format('DD.MM.YYYY') : '' }}</h3>
                <div v-html="n.inhalt"></div>
            </v-card-text>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.news {
    h2 {
        font-size: 1.2em;
        color: #333;
    }

    h3 {
        font-size: 1em;
        color: #888;
    }
}
</style>
